import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {socket} from '../EntryShared'
import {GameColor} from '../GameColor'
import {TranslationObject} from '@colonist/i18n'
import {escapeRegExp, escape} from 'lodash'
import {ImageURL, PLAYER_DISPLAY_NAME_END, PLAYER_DISPLAY_NAME_START} from '@colonist/types'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {CardEnum, PlayerColor} from '@colonist/game-states'
import {UIGameConstants} from '../ui_game/UIGameConstants.ts'
import CardLumber from '@static/images/card_lumber.svg'
import CardBrick from '@static/images/card_brick.svg'
import CardWool from '@static/images/card_wool.svg'
import CardGrain from '@static/images/card_grain.svg'
import CardPaper from '@static/images/card_paper.svg'
import CardCloth from '@static/images/card_cloth.svg'
import CardCoin from '@static/images/card_coin.svg'
import CardOre from '@static/images/card_ore.svg'
import TileLumber from '@static/images/tile_lumber.svg'
import TileBrick from '@static/images/tile_brick.svg'
import TileWool from '@static/images/tile_wool.svg'
import TileGrain from '@static/images/tile_grain.svg'
import TileOre from '@static/images/tile_ore.svg'
import TileDesert from '@static/images/tile_desert.svg'
import TileGold from '@static/images/tile_gold.svg'
import CardKnight from '@static/images/card_knight.svg'
import IconRobber from '@static/images/icon_robber.svg'
import IconPirateShip from '@static/images/icon_pirate_ship.svg'
import IconTrophy from '@static/images/icon_trophy.svg'
import IconChit from '@static/images/icon_chit.svg'
import IconLargestArmy from '@static/images/icon_largest_army.svg'
import IconLongestRoad from '@static/images/icon_longest_road.svg'
import IconMerchantBlack from '@static/images/icon_merchant_black.svg'
import IconMerchantBlue from '@static/images/icon_merchant_blue.svg'
import IconMerchantBronze from '@static/images/icon_merchant_bronze.svg'
import IconMerchantGold from '@static/images/icon_merchant_gold.svg'
import IconMerchantGreen from '@static/images/icon_merchant_green.svg'
import IconMerchantMysticBlue from '@static/images/icon_merchant_mysticblue.svg'
import IconMerchantOrange from '@static/images/icon_merchant_orange.svg'
import IconMerchantPurple from '@static/images/icon_merchant_purple.svg'
import IconMerchantRed from '@static/images/icon_merchant_red.svg'
import IconMerchantSilver from '@static/images/icon_merchant_silver.svg'
import IconMerchantWhite from '@static/images/icon_merchant_white.svg'
import IconMerchantPink from '@static/images/icon_merchant_pink.svg'
import MetropolisScience from '@static/images/metropolis_science.svg'
import MetropolisTrade from '@static/images/metropolis_trade.svg'
import MetropolisPolitics from '@static/images/metropolis_politics.svg'
import IconLightning from '@static/images/icon_lightning.svg'
import IconPlayer from '@static/images/icon_player.svg'
import IconMail from '@static/images/icon_mail.svg'
import IconSettler from '@static/images/icon_settler.svg'
import IconColonist from '@static/images/icon_colonist.svg'
import IconFounder from '@static/images/icon_founder.svg'
import IconAdmin from '@static/images/icon_admin.svg'
import IconModerator from '@static/images/icon_moderator.svg'
import IconBot from '@static/images/icon_bot.svg'
import Dice1 from '@static/images/dice_1.svg'
import Dice2 from '@static/images/dice_2.svg'
import Dice3 from '@static/images/dice_3.svg'
import Dice4 from '@static/images/dice_4.svg'
import Dice5 from '@static/images/dice_5.svg'
import Dice6 from '@static/images/dice_6.svg'
import DiceRed1 from '@static/images/dice_red_1.svg'
import DiceRed2 from '@static/images/dice_red_2.svg'
import DiceRed3 from '@static/images/dice_red_3.svg'
import DiceRed4 from '@static/images/dice_red_4.svg'
import DiceRed5 from '@static/images/dice_red_5.svg'
import DiceRed6 from '@static/images/dice_red_6.svg'
import DiceEventBarbarian from '@static/images/dice_event_barbarian.svg'
import DiceEventScience from '@static/images/dice_event_science.svg'
import DiceEventTrade from '@static/images/dice_event_trade.svg'
import DiceEventPolitics from '@static/images/dice_event_politics.svg'
import Prob2 from '@static/images/prob_2.svg'
import Prob3 from '@static/images/prob_3.svg'
import Prob4 from '@static/images/prob_4.svg'
import Prob5 from '@static/images/prob_5.svg'
import Prob6 from '@static/images/prob_6.svg'
import Prob8 from '@static/images/prob_8.svg'
import Prob9 from '@static/images/prob_9.svg'
import Prob10 from '@static/images/prob_10.svg'
import Prob11 from '@static/images/prob_11.svg'
import Prob12 from '@static/images/prob_12.svg'
import Partition from '@static/images/partition.svg'
import KnightLevel1ActiveBlack from '@static/images/knight_level1_active_black.svg'
import KnightLevel2ActiveBlack from '@static/images/knight_level2_active_black.svg'
import KnightLevel3ActiveBlack from '@static/images/knight_level3_active_black.svg'
import KnightLevel1InactiveBlack from '@static/images/knight_level1_inactive_black.svg'
import KnightLevel2InactiveBlack from '@static/images/knight_level2_inactive_black.svg'
import KnightLevel3InactiveBlack from '@static/images/knight_level3_inactive_black.svg'
import KnightLevel1ActiveBlue from '@static/images/knight_level1_active_blue.svg'
import KnightLevel2ActiveBlue from '@static/images/knight_level2_active_blue.svg'
import KnightLevel3ActiveBlue from '@static/images/knight_level3_active_blue.svg'
import KnightLevel1InactiveBlue from '@static/images/knight_level1_inactive_blue.svg'
import KnightLevel2InactiveBlue from '@static/images/knight_level2_inactive_blue.svg'
import KnightLevel3InactiveBlue from '@static/images/knight_level3_inactive_blue.svg'
import KnightLevel1ActiveBronze from '@static/images/knight_level1_active_bronze.svg'
import KnightLevel2ActiveBronze from '@static/images/knight_level2_active_bronze.svg'
import KnightLevel3ActiveBronze from '@static/images/knight_level3_active_bronze.svg'
import KnightLevel1InactiveBronze from '@static/images/knight_level1_inactive_bronze.svg'
import KnightLevel2InactiveBronze from '@static/images/knight_level2_inactive_bronze.svg'
import KnightLevel3InactiveBronze from '@static/images/knight_level3_inactive_bronze.svg'
import KnightLevel1ActiveGold from '@static/images/knight_level1_active_gold.svg'
import KnightLevel2ActiveGold from '@static/images/knight_level2_active_gold.svg'
import KnightLevel3ActiveGold from '@static/images/knight_level3_active_gold.svg'
import KnightLevel1InactiveGold from '@static/images/knight_level1_inactive_gold.svg'
import KnightLevel2InactiveGold from '@static/images/knight_level2_inactive_gold.svg'
import KnightLevel3InactiveGold from '@static/images/knight_level3_inactive_gold.svg'
import KnightLevel1ActiveGreen from '@static/images/knight_level1_active_green.svg'
import KnightLevel2ActiveGreen from '@static/images/knight_level2_active_green.svg'
import KnightLevel3ActiveGreen from '@static/images/knight_level3_active_green.svg'
import KnightLevel1InactiveGreen from '@static/images/knight_level1_inactive_green.svg'
import KnightLevel2InactiveGreen from '@static/images/knight_level2_inactive_green.svg'
import KnightLevel3InactiveGreen from '@static/images/knight_level3_inactive_green.svg'
import KnightLevel1ActiveMysticBlue from '@static/images/knight_level1_active_mysticblue.svg'
import KnightLevel2ActiveMysticBlue from '@static/images/knight_level2_active_mysticblue.svg'
import KnightLevel3ActiveMysticBlue from '@static/images/knight_level3_active_mysticblue.svg'
import KnightLevel1InactiveMysticBlue from '@static/images/knight_level1_inactive_mysticblue.svg'
import KnightLevel2InactiveMysticBlue from '@static/images/knight_level2_inactive_mysticblue.svg'
import KnightLevel3InactiveMysticBlue from '@static/images/knight_level3_inactive_mysticblue.svg'
import KnightLevel1ActiveOrange from '@static/images/knight_level1_active_orange.svg'
import KnightLevel2ActiveOrange from '@static/images/knight_level2_active_orange.svg'
import KnightLevel3ActiveOrange from '@static/images/knight_level3_active_orange.svg'
import KnightLevel1InactiveOrange from '@static/images/knight_level1_inactive_orange.svg'
import KnightLevel2InactiveOrange from '@static/images/knight_level2_inactive_orange.svg'
import KnightLevel3InactiveOrange from '@static/images/knight_level3_inactive_orange.svg'
import KnightLevel1ActivePurple from '@static/images/knight_level1_active_purple.svg'
import KnightLevel2ActivePurple from '@static/images/knight_level2_active_purple.svg'
import KnightLevel3ActivePurple from '@static/images/knight_level3_active_purple.svg'
import KnightLevel1InactivePurple from '@static/images/knight_level1_inactive_purple.svg'
import KnightLevel2InactivePurple from '@static/images/knight_level2_inactive_purple.svg'
import KnightLevel3InactivePurple from '@static/images/knight_level3_inactive_purple.svg'
import KnightLevel1ActiveRed from '@static/images/knight_level1_active_red.svg'
import KnightLevel2ActiveRed from '@static/images/knight_level2_active_red.svg'
import KnightLevel3ActiveRed from '@static/images/knight_level3_active_red.svg'
import KnightLevel1InactiveRed from '@static/images/knight_level1_inactive_red.svg'
import KnightLevel2InactiveRed from '@static/images/knight_level2_inactive_red.svg'
import KnightLevel3InactiveRed from '@static/images/knight_level3_inactive_red.svg'
import KnightLevel1ActiveSilver from '@static/images/knight_level1_active_silver.svg'
import KnightLevel2ActiveSilver from '@static/images/knight_level2_active_silver.svg'
import KnightLevel3ActiveSilver from '@static/images/knight_level3_active_silver.svg'
import KnightLevel1InactiveSilver from '@static/images/knight_level1_inactive_silver.svg'
import KnightLevel2InactiveSilver from '@static/images/knight_level2_inactive_silver.svg'
import KnightLevel3InactiveSilver from '@static/images/knight_level3_inactive_silver.svg'
import KnightLevel1ActiveWhite from '@static/images/knight_level1_active_white.svg'
import KnightLevel2ActiveWhite from '@static/images/knight_level2_active_white.svg'
import KnightLevel3ActiveWhite from '@static/images/knight_level3_active_white.svg'
import KnightLevel1InactiveWhite from '@static/images/knight_level1_inactive_white.svg'
import KnightLevel2InactiveWhite from '@static/images/knight_level2_inactive_white.svg'
import KnightLevel3InactiveWhite from '@static/images/knight_level3_inactive_white.svg'
import KnightLevel1ActivePink from '@static/images/knight_level1_active_pink.svg'
import KnightLevel2ActivePink from '@static/images/knight_level2_active_pink.svg'
import KnightLevel3ActivePink from '@static/images/knight_level3_active_pink.svg'
import KnightLevel1InactivePink from '@static/images/knight_level1_inactive_pink.svg'
import KnightLevel2InactivePink from '@static/images/knight_level2_inactive_pink.svg'
import KnightLevel3InactivePink from '@static/images/knight_level3_inactive_pink.svg'
import IconSquareFramedPolitics from '@static/images/icon_square_framed_politics.svg'
import IconSquareFramedScience from '@static/images/icon_square_framed_science.svg'
import IconSquareFramedTrade from '@static/images/icon_square_framed_trade.svg'
import {UIImagePathController} from '../UIEnums.ts'
import {EnumUtils} from '@colonist/utils'
import {CARD_IMAGES} from '@colonist/ui-game'
import {CardDataController} from '@colonist/game-card-types'
import {clientI18n} from '../ClientI18n.ts'

interface ImageDictionary {[imageChatString: string]: string}

export class UIUtilsChat {
    private static imageDictionaryRegex: RegExp
    private static readonly playerImageMap: Map<PlayerColor, ImageDictionary> = new Map()
    static readonly OPEN_RULEBOOK_LINK_HASH = '#open-rulebook'

    static replaceKeywordsWithImages(str: string): string {
        const playerColor = this.getPlayerColorFromText(str) ?? PlayerColor.Red
        const imageDictionary = this.getImageMapObject(playerColor)

        const imageKeywordRegex = this.getImageDictionaryRegex(playerColor)
        const usernameRegex = this.regexToMatchUsername()

        const usernameAndKeywordRegex = new RegExp(`(${usernameRegex.source}|${imageKeywordRegex.source})`, 'gi')

        const replacedString = str.replace(usernameAndKeywordRegex, (matched: string) => {
            const isMatchedStringUsername = usernameRegex.test(matched)
            if(isMatchedStringUsername) return matched

            const key = matched.toLowerCase()
            return imageDictionary[key] ?? matched
        })
        return replacedString
    }

    static colorAndBoldUsernames(str: string): string {
        const eachUsernameInStr = UIUtilsChat.regexToMatchUsername()

        return str.replace(eachUsernameInStr, (matched: string) => this.getHighlightedUsername(matched))
    }

    static getHighlightedUsername(username: string): string {
        username = UIUtilsChat.stripPlayerMarkers(username)
        const textColor = UIUtilsChat.getTextColor(UIUtilsChat.getUsernameCorrectCapitalization(username), GameColor.getColor(GameColor.Color.Gray0))
        return '<span style="font-weight:600;word-break:break-all;color:' + textColor + '">' + username + '</span>'
    }

    private static getUsernameCorrectCapitalization(usernameWithAnyCapitalization: string): string {
        const usernameList = UIUtilsChat.getUsernameList()
        return usernameList.find((username: string) => username.toLowerCase() == usernameWithAnyCapitalization.toLowerCase()) ?? ''
    }

    private static getImageDictionaryRegex(playerColor: PlayerColor): RegExp {
        if(this.imageDictionaryRegex != undefined) return this.imageDictionaryRegex

        const imageDictionaryKeys = Object.keys(this.getImageMapObject(playerColor))
        const regexToMatchOneDictionaryKey = this.regexToMatchOneOfList(imageDictionaryKeys)
        this.imageDictionaryRegex = regexToMatchOneDictionaryKey
        return regexToMatchOneDictionaryKey
    }

    static getTextColor(text: string, color: string): string {
        const playerColor = this.getPlayerColorFromText(text)
        if(playerColor != undefined) return UIUtilsEjsVariables.isUserOnMobileApp ? GameColor.getPlayerBGDarkHashForMobile(playerColor) : GameColor.getPlayerBGDarkHash(playerColor)
        return color
    }

    static getUsernameList(): string[] {
        if(socket?.gameListener.gameState?.players.length > 0) {
            return socket.gameListener.gameState.players.map((player: PlayerValidator) => player.username)
        }
        if(socket?.lobbyListener.room?.getUsernames() != undefined) {
            return socket.lobbyListener.room.getUsernames()
        }
        return []
    }

    static stripPlayerMarkers(name: string | undefined): string {
        return (name ?? '')
            .replaceAll(PLAYER_DISPLAY_NAME_START, '')
            .replaceAll(PLAYER_DISPLAY_NAME_END, '')
    }

    static regexToMatchUsername(): RegExp {
        const usernameList = this.getUsernameList()
        const usernameMatches = usernameList.map((username) => `(?:${PLAYER_DISPLAY_NAME_START}|\\b)${escapeRegExp(username)}(?:${PLAYER_DISPLAY_NAME_END}|\\b)`)
        return UIUtilsChat.regexToMatchOneOfList(usernameMatches)
    }

    static regexToMatchOneOfList(items: string[]): RegExp {
        const itemsSeparatedByPipe: string = items.join('|')
        const regexOneOfPipedItems = new RegExp(itemsSeparatedByPipe, 'gi')
        return regexOneOfPipedItems
    }

    static getPlayerColorFromText(text: string): PlayerColor | undefined {
        let playerNameIndexBestMatch = -1
        let playerNameIndexBestMatchLength = -1
        let playerColor: PlayerColor = PlayerColor.Red

        const players = socket?.gameListener.gameState?.players
        if(players === undefined) return

        for(const player of players) {
            const playerNameIndex = UIUtilsChat.getTextIndexForPlayer(text, player)
            if(playerNameIndex == -1) continue

            const isFirstOccurringPlayerName = playerNameIndex < playerNameIndexBestMatch
            const playerNameIsBetterMatch = (playerNameIndex == playerNameIndexBestMatch && player.username.length > playerNameIndexBestMatchLength)

            if(playerNameIndexBestMatch == -1 || isFirstOccurringPlayerName || playerNameIsBetterMatch) {
                playerNameIndexBestMatch = playerNameIndex
                playerNameIndexBestMatchLength = player.username.length
                playerColor = player.color
            }
        }

        return playerNameIndexBestMatch == -1 ? undefined : playerColor
    }

    private static getTextIndexForPlayer(text: string, player: PlayerValidator): number {
        const youIndex = text.indexOf('You')
        const isYourColor = player.color == PlayerColor.None // TODO: Make PlayerColor.None -> gameController.myColor
        const playerNameIndex = text.indexOf(player.username)
        if(playerNameIndex == -1 && isYourColor) return youIndex

        return playerNameIndex
    }

    /**
     * @deprecated Use UIGameChatDebugMessage.tsx instead
     */
    static getDebugClientText(text: string): TranslationObject | undefined {
        if(text != '/debug') return undefined
        const message = ':private:' +
            '<br>userAgent: ' + navigator.userAgent +
            '<br>language: ' + navigator.language +
            '<br>cookieEnabled: ' + navigator.cookieEnabled +
            '<br>innerHeight: ' + window.innerHeight +
            '<br>innerWidth: ' + window.innerWidth +
            '<br>outerHeight: ' + window.outerHeight +
            '<br>outerWidth: ' + window.outerWidth
        return {key: 'strings:colonistCommon.utils.#buffer', options: {value: message, interpolation: {escapeValue: false}}}
    }

    private static getImageMapObject(playerColor: PlayerColor): ImageDictionary {
        const playerImageMapObject = this.playerImageMap.get(playerColor)
        if(playerImageMapObject != undefined) return playerImageMapObject

        const newPlayerImageMapObject = this.createImageMapObject(playerColor)
        this.playerImageMap.set(playerColor, newPlayerImageMapObject)
        return newPlayerImageMapObject
    }

    private static createImageMapObject(playerColor: PlayerColor): ImageDictionary {
        // TODO missing translations for alt texts
        /* eslint-disable  @typescript-eslint/naming-convention */
        const images: Record<string, string> = {
            lumber: constructImgCard(CardLumber, 'lumber'),
            wood: constructImgCard(CardLumber, 'wood'),
            brick: constructImgCard(CardBrick, 'brick'),
            wool: constructImgCard(CardWool, 'wool'),
            sheep: constructImgCard(CardWool, 'wool'),
            grain: constructImgCard(CardGrain, 'grain'),
            wheat: constructImgCard(CardGrain, 'grain'),
            paper: constructImgCard(CardPaper, 'paper'),
            cloth: constructImgCard(CardCloth, 'cloth'),
            coin: constructImgCard(CardCoin, 'coin'),
            ' ore': ' ' + constructImgCard(CardOre, 'ore'),

            ':tile_lumber:': constructImgTile(TileLumber, 'lumber tile'),
            ':tile_brick:': constructImgTile(TileBrick, 'brick tile'),
            ':tile_wool:': constructImgTile(TileWool, 'wool tile'),
            ':tile_grain:': constructImgTile(TileGrain, 'grain tile'),
            ':tile_ore:': constructImgTile(TileOre, 'ore tile'),
            ':tile_desert:': constructImgTile(TileDesert, 'desert tile'),
            ':tile_gold:': constructImgTile(TileGold, 'gold tile'),

            /* won't be used for robber log and players using these seems unlikely
            ':tile_fog:': constructImgTile(TileFog, 'fog tile'),

            ':tile_shore_1:': constructImgTile(TileShore1, 'shore tile'),
            ':tile_shore_2_sswwww:': constructImgTile(TileShore2Sswwww, 'shore tile'),
            ':tile_shore_2_swswww:': constructImgTile(TileShore2Swswww, 'shore tile'),
            ':tile_shore_2_ssswww:': constructImgTile(TileShore2Ssswww, 'shore tile'),
            ':tile_shore_3_sswwsw:': constructImgTile(TileShore3Sswwsw, 'shore tile'),
            ':tile_shore_3_swswsw:': constructImgTile(TileShore3Swswsw, 'shore tile'),
            ':tile_shore_4_ssssww:': constructImgTile(TileShore4Ssssww, 'shore tile'),
            ':tile_shore_4_ssswsw:': constructImgTile(TileShore4Ssswsw, 'shore tile'),
            ':tile_shore_4_sswssw:': constructImgTile(TileShore4Sswssw, 'shore tile'),
            ':tile_shore_5:': constructImgTile(TileShore5, 'shore tile'),
            ':tile_shore_6:': constructImgTile(TileShore6, 'shore tile'),
            */

            ':knight:': constructImgCard(CardKnight, 'knight'),

            ':robber:': constructImgTag(IconRobber, 'robber'),
            pirate: constructImgTag(IconPirateShip, 'pirate'),
            trophy: constructImgTag(IconTrophy, 'trophy'),
            ':chit:': constructImgTag(IconChit, 'chit'),
            largestarmy: constructImgTag(IconLargestArmy, 'largest army'),
            longestroad: constructImgTag(IconLongestRoad, 'longest road'),

            ':icon_merchant_black:': constructImgTag(IconMerchantBlack, 'Merchant black'),
            ':icon_merchant_blue:': constructImgTag(IconMerchantBlue, 'Merchant blue'),
            ':icon_merchant_bronze:': constructImgTag(IconMerchantBronze, 'Merchant bronze'),
            ':icon_merchant_gold:': constructImgTag(IconMerchantGold, 'Merchant gold'),
            ':icon_merchant_green:': constructImgTag(IconMerchantGreen, 'Merchant green'),
            ':icon_merchant_mysticblue:': constructImgTag(IconMerchantMysticBlue, 'Merchant mystic blue'),
            ':icon_merchant_orange:': constructImgTag(IconMerchantOrange, 'Merchant orange'),
            ':icon_merchant_purple:': constructImgTag(IconMerchantPurple, 'Merchant purple'),
            ':icon_merchant_red:': constructImgTag(IconMerchantRed, 'Merchant red'),
            ':icon_merchant_silver:': constructImgTag(IconMerchantSilver, 'Merchant silver'),
            ':icon_merchant_white:': constructImgTag(IconMerchantWhite, 'Merchant white'),
            ':icon_merchant_pink:': constructImgTag(IconMerchantPink, 'Merchant pink'),

            ':road:': constructImgTag(UIImagePathController.roadsByColor[playerColor], 'road'),
            ':ship:': constructImgTag(UIImagePathController.shipsByColor[playerColor], 'ship'),
            settlement: constructImgTag(UIImagePathController.settlementsByColor[playerColor], 'settlement'),
            ':house:': constructImgTag(UIImagePathController.settlementsByColor[playerColor], ':house:'),
            city: constructImgTag(UIImagePathController.citiesByColor[playerColor], 'city'),
            ':city_wall:': constructImgTag(UIImagePathController.cityWallsByColor[playerColor], 'city wall'),
            ':metropolis_science:': constructImgTag(MetropolisScience, 'metropolis_science'),
            ':metropolis_trade:': constructImgTag(MetropolisTrade, 'metropolis_trade'),
            ':metropolis_politics:': constructImgTag(MetropolisPolitics, 'metropolis_politics'),

            ':private:': constructImgTag(IconLightning, ''),
            ':public:': constructImgTag(IconPlayer, ''),
            ':mail:': constructImgTag(IconMail, ''),

            ':pack_settler:': constructImgTag(IconSettler, ''),
            ':pack_colonist:': constructImgTag(IconColonist, ''),
            ':pack_founder:': constructImgTag(IconFounder, ''),

            ':admin:': constructImgTag(IconAdmin, ''),
            ':moderator:': constructImgTag(IconModerator, ''),
            ':bot:': constructImgTag(IconBot, ''),

            ':dice:1': constructImgTag(Dice1, 'dice_1'),
            ':dice:2': constructImgTag(Dice2, 'dice_2'),
            ':dice:3': constructImgTag(Dice3, 'dice_3'),
            ':dice:4': constructImgTag(Dice4, 'dice_4'),
            ':dice:5': constructImgTag(Dice5, 'dice_5'),
            ':dice:6': constructImgTag(Dice6, 'dice_6'),

            ':dice_red:1': constructImgTag(DiceRed1, 'dice_red_1'),
            ':dice_red:2': constructImgTag(DiceRed2, 'dice_red_2'),
            ':dice_red:3': constructImgTag(DiceRed3, 'dice_red_3'),
            ':dice_red:4': constructImgTag(DiceRed4, 'dice_red_4'),
            ':dice_red:5': constructImgTag(DiceRed5, 'dice_red_5'),
            ':dice_red:6': constructImgTag(DiceRed6, 'dice_red_6'),

            ':dice_event:1': constructImgTag(DiceEventBarbarian, 'dice_barbarian'),
            ':dice_event:2': constructImgTag(DiceEventBarbarian, 'dice_barbarian'),
            ':dice_event:3': constructImgTag(DiceEventBarbarian, 'dice_barbarian'),
            ':dice_event:4': constructImgTag(DiceEventScience, 'dice_science'),
            ':dice_event:5': constructImgTag(DiceEventTrade, 'dice_trade'),
            ':dice_event:6': constructImgTag(DiceEventPolitics, 'dice_politics'),

            ':prob:2': constructImgTag(Prob2, 'prob_2'),
            ':prob:3': constructImgTag(Prob3, 'prob_3'),
            ':prob:4': constructImgTag(Prob4, 'prob_4'),
            ':prob:5': constructImgTag(Prob5, 'prob_5'),
            ':prob:6': constructImgTag(Prob6, 'prob_6'),
            ':prob:8': constructImgTag(Prob8, 'prob_8'),
            ':prob:9': constructImgTag(Prob9, 'prob_9'),
            ':prob:10': constructImgTag(Prob10, 'prob_10'),
            ':prob:11': constructImgTag(Prob11, 'prob_11'),
            ':prob:12': constructImgTag(Prob12, 'prob_12'),

            ':partition:': constructImgTag(Partition, ':partition:', 0.6),

            ':knight_active_level1_black:': constructImgTag(KnightLevel1ActiveBlack, 'Knight'),
            ':knight_active_level2_black:': constructImgTag(KnightLevel2ActiveBlack, 'Knight'),
            ':knight_active_level3_black:': constructImgTag(KnightLevel3ActiveBlack, 'Knight'),
            ':knight_inactive_level1_black:': constructImgTag(KnightLevel1InactiveBlack, 'Knight'),
            ':knight_inactive_level2_black:': constructImgTag(KnightLevel2InactiveBlack, 'Knight'),
            ':knight_inactive_level3_black:': constructImgTag(KnightLevel3InactiveBlack, 'Knight'),

            ':knight_active_level1_blue:': constructImgTag(KnightLevel1ActiveBlue, 'Knight'),
            ':knight_active_level2_blue:': constructImgTag(KnightLevel2ActiveBlue, 'Knight'),
            ':knight_active_level3_blue:': constructImgTag(KnightLevel3ActiveBlue, 'Knight'),
            ':knight_inactive_level1_blue:': constructImgTag(KnightLevel1InactiveBlue, 'Knight'),
            ':knight_inactive_level2_blue:': constructImgTag(KnightLevel2InactiveBlue, 'Knight'),
            ':knight_inactive_level3_blue:': constructImgTag(KnightLevel3InactiveBlue, 'Knight'),

            ':knight_active_level1_bronze:': constructImgTag(KnightLevel1ActiveBronze, 'Knight'),
            ':knight_active_level2_bronze:': constructImgTag(KnightLevel2ActiveBronze, 'Knight'),
            ':knight_active_level3_bronze:': constructImgTag(KnightLevel3ActiveBronze, 'Knight'),
            ':knight_inactive_level1_bronze:': constructImgTag(KnightLevel1InactiveBronze, 'Knight'),
            ':knight_inactive_level2_bronze:': constructImgTag(KnightLevel2InactiveBronze, 'Knight'),
            ':knight_inactive_level3_bronze:': constructImgTag(KnightLevel3InactiveBronze, 'Knight'),

            ':knight_active_level1_gold:': constructImgTag(KnightLevel1ActiveGold, 'Knight'),
            ':knight_active_level2_gold:': constructImgTag(KnightLevel2ActiveGold, 'Knight'),
            ':knight_active_level3_gold:': constructImgTag(KnightLevel3ActiveGold, 'Knight'),
            ':knight_inactive_level1_gold:': constructImgTag(KnightLevel1InactiveGold, 'Knight'),
            ':knight_inactive_level2_gold:': constructImgTag(KnightLevel2InactiveGold, 'Knight'),
            ':knight_inactive_level3_gold:': constructImgTag(KnightLevel3InactiveGold, 'Knight'),

            ':knight_active_level1_green:': constructImgTag(KnightLevel1ActiveGreen, 'Knight'),
            ':knight_active_level2_green:': constructImgTag(KnightLevel2ActiveGreen, 'Knight'),
            ':knight_active_level3_green:': constructImgTag(KnightLevel3ActiveGreen, 'Knight'),
            ':knight_inactive_level1_green:': constructImgTag(KnightLevel1InactiveGreen, 'Knight'),
            ':knight_inactive_level2_green:': constructImgTag(KnightLevel2InactiveGreen, 'Knight'),
            ':knight_inactive_level3_green:': constructImgTag(KnightLevel3InactiveGreen, 'Knight'),

            ':knight_active_level1_mysticblue:': constructImgTag(KnightLevel1ActiveMysticBlue, 'Knight'),
            ':knight_active_level2_mysticblue:': constructImgTag(KnightLevel2ActiveMysticBlue, 'Knight'),
            ':knight_active_level3_mysticblue:': constructImgTag(KnightLevel3ActiveMysticBlue, 'Knight'),
            ':knight_inactive_level1_mysticblue:': constructImgTag(KnightLevel1InactiveMysticBlue, 'Knight'),
            ':knight_inactive_level2_mysticblue:': constructImgTag(KnightLevel2InactiveMysticBlue, 'Knight'),
            ':knight_inactive_level3_mysticblue:': constructImgTag(KnightLevel3InactiveMysticBlue, 'Knight'),

            ':knight_active_level1_orange:': constructImgTag(KnightLevel1ActiveOrange, 'Knight'),
            ':knight_active_level2_orange:': constructImgTag(KnightLevel2ActiveOrange, 'Knight'),
            ':knight_active_level3_orange:': constructImgTag(KnightLevel3ActiveOrange, 'Knight'),
            ':knight_inactive_level1_orange:': constructImgTag(KnightLevel1InactiveOrange, 'Knight'),
            ':knight_inactive_level2_orange:': constructImgTag(KnightLevel2InactiveOrange, 'Knight'),
            ':knight_inactive_level3_orange:': constructImgTag(KnightLevel3InactiveOrange, 'Knight'),

            ':knight_active_level1_purple:': constructImgTag(KnightLevel1ActivePurple, 'Knight'),
            ':knight_active_level2_purple:': constructImgTag(KnightLevel2ActivePurple, 'Knight'),
            ':knight_active_level3_purple:': constructImgTag(KnightLevel3ActivePurple, 'Knight'),
            ':knight_inactive_level1_purple:': constructImgTag(KnightLevel1InactivePurple, 'Knight'),
            ':knight_inactive_level2_purple:': constructImgTag(KnightLevel2InactivePurple, 'Knight'),
            ':knight_inactive_level3_purple:': constructImgTag(KnightLevel3InactivePurple, 'Knight'),

            ':knight_active_level1_red:': constructImgTag(KnightLevel1ActiveRed, 'Knight'),
            ':knight_active_level2_red:': constructImgTag(KnightLevel2ActiveRed, 'Knight'),
            ':knight_active_level3_red:': constructImgTag(KnightLevel3ActiveRed, 'Knight'),
            ':knight_inactive_level1_red:': constructImgTag(KnightLevel1InactiveRed, 'Knight'),
            ':knight_inactive_level2_red:': constructImgTag(KnightLevel2InactiveRed, 'Knight'),
            ':knight_inactive_level3_red:': constructImgTag(KnightLevel3InactiveRed, 'Knight'),

            ':knight_active_level1_silver:': constructImgTag(KnightLevel1ActiveSilver, 'Knight'),
            ':knight_active_level2_silver:': constructImgTag(KnightLevel2ActiveSilver, 'Knight'),
            ':knight_active_level3_silver:': constructImgTag(KnightLevel3ActiveSilver, 'Knight'),
            ':knight_inactive_level1_silver:': constructImgTag(KnightLevel1InactiveSilver, 'Knight'),
            ':knight_inactive_level2_silver:': constructImgTag(KnightLevel2InactiveSilver, 'Knight'),
            ':knight_inactive_level3_silver:': constructImgTag(KnightLevel3InactiveSilver, 'Knight'),

            ':knight_active_level1_white:': constructImgTag(KnightLevel1ActiveWhite, 'Knight'),
            ':knight_active_level2_white:': constructImgTag(KnightLevel2ActiveWhite, 'Knight'),
            ':knight_active_level3_white:': constructImgTag(KnightLevel3ActiveWhite, 'Knight'),
            ':knight_inactive_level1_white:': constructImgTag(KnightLevel1InactiveWhite, 'Knight'),
            ':knight_inactive_level2_white:': constructImgTag(KnightLevel2InactiveWhite, 'Knight'),
            ':knight_inactive_level3_white:': constructImgTag(KnightLevel3InactiveWhite, 'Knight'),

            ':knight_active_level1_pink:': constructImgTag(KnightLevel1ActivePink, 'Knight'),
            ':knight_active_level2_pink:': constructImgTag(KnightLevel2ActivePink, 'Knight'),
            ':knight_active_level3_pink:': constructImgTag(KnightLevel3ActivePink, 'Knight'),
            ':knight_inactive_level1_pink:': constructImgTag(KnightLevel1InactivePink, 'Knight'),
            ':knight_inactive_level2_pink:': constructImgTag(KnightLevel2InactivePink, 'Knight'),
            ':knight_inactive_level3_pink:': constructImgTag(KnightLevel3InactivePink, 'Knight'),

            ':icon_square_framed_politics:': constructImgTag(IconSquareFramedPolitics, 'politics square', 0.8),
            ':icon_square_framed_science:': constructImgTag(IconSquareFramedScience, 'science square', 0.8),
            ':icon_square_framed_trade:': constructImgTag(IconSquareFramedTrade, 'trade square', 0.8),
        }

        EnumUtils.loopEnums(CardEnum, (name, cardEnum) => {
            const card = CardDataController.getCardDataForCard(cardEnum)
            if(card == undefined) return

            images[`:card_${cardEnum}:`] = constructImgCard(CARD_IMAGES[cardEnum], clientI18n.t(card.tipTitle.key, card.tipTitle.options))
        })

        /* eslint-enable  @typescript-eslint/naming-convention */
        return images
    }
}

const IMG_SIZE = 20

function constructImgCard(path: ImageURL, alt: string): string {
    const size = IMG_SIZE
    const sizeStr = '" height="' + size + '" width="' + size / UIGameConstants.CARD_RATIO

    return '<img src="' + path + '" alt="' + escape(alt) + sizeStr + '" class="lobby-chat-text-icon">'
}

function constructImgTile(path: ImageURL, alt: string): string {
    const size = IMG_SIZE
    const sizeStr = '" height="' + size + '" width="' + IMG_SIZE / UIGameConstants.TILE_RATIO
    return '<img src="' + path + '" alt="' + escape(alt) + sizeStr + '" class="lobby-chat-text-icon">'
}

function constructImgTag(path: ImageURL, alt: string, sizeFactor: number = 1): string {
    const size = IMG_SIZE * sizeFactor
    const sizeStr = '" height="' + size + '" width="' + size
    return '<img src="' + path + '" alt="' + escape(alt) + sizeStr + '" class="lobby-chat-text-icon">'
}
